import { Assets, Spritesheet, Texture } from 'pixi.js'

// 底部操作列貼圖 — 由 scripts/gen-atlas.mjs 合成的 spritesheet（public/atlas/bottombar.webp + .json）取得。
// frame key 即各素材檔名（不含副檔名）。
const ATLAS = `${import.meta.env.BASE_URL}atlas/bottombar.json`

const NAMES = [
  'btn_spin_up',
  'btn_spin_stop',
  'btn_fast_normal',
  'btn_fast_quick',
  'btn_auto',
  'btn_auto_on',
  'btn_double_off',
  'btn_double_on',
  'btn_extrabet_off',
  'btn_extrabet_on',
  'btn_plus',
  'btn_minus',
  'pic_under_land',
  'btn_set',
  'btn_info',
  'btn_wallet',
  'pic_marquee_1',
] as const
export type BottomBarTextureName = (typeof NAMES)[number]

const textures: Partial<Record<BottomBarTextureName, Texture>> = {}

export async function loadBottomBarTextures(): Promise<void> {
  const sheet = await Assets.load<Spritesheet>(ATLAS)
  for (const name of NAMES) {
    const tex = sheet.textures[name]
    if (tex) textures[name] = tex
  }
}

export function bottomBarTexture(name: BottomBarTextureName): Texture {
  return textures[name] ?? Texture.EMPTY
}
